import Register from "./components/Register";
import ipConfig from "./ipConfig.json";
import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import Checkout from "./components/Checkout";
import Thanks from "./components/Thanks";
// import theme from "./theme.js";
// import { ThemeProvider } from '@mui/material/styles';

export const config = {
  // endpoint: `http://${ipConfig.workspaceIp}:8082/api/v1`,
  endpoint : `https://qkart-frontend-55el.onrender.com/api/v1`
};

function App() {
  return (
    <div className="App">
      {/* TODO: CRIO_TASK_MODULE_LOGIN - To add configure routes and their mapping */}
          {/* <Register /> */}
          {/* <ThemeProvider theme={theme}> */}
              {/* <Login /> */}
              <Switch>
              <Route exact path="/thanks" component={Thanks} />
              <Route exact path="/checkout" component={Checkout} />
              <Route exact path="/register" component={Register} />
              <Route exact path="/login" component={Login} />
              <Route path="/" component={Products} />
              
              </Switch>
          {/* </ThemeProvider> */}
          
    </div>
  );
}

export default App;
